// extracted by mini-css-extract-plugin
module.exports = {"iframe":"Main_iframe__3FItb","panel":"Main_panel__gXvgn"};